export default __webpack_public_path__ + "static/media/vimeo_logo_white.c8f1c6f4.svg";